import _ from 'lodash';
import { useMemo } from 'react';

import { selectReactionsCount } from 'client/redux/pubnub/selectors';
import { PubnubState } from 'client/redux/pubnub';

import { useAppSelector } from './redux';

export function useReactionsCount(): { reactionsCount: PubnubState['reactions']['counts'] | null; total: number } {
  const reactionsCount = useAppSelector(selectReactionsCount);

  const total = useMemo(() => {
    if (reactionsCount) {
      return _.reduce(
        reactionsCount,
        (acc, item) => {
          acc += item;
          return acc;
        },
        0,
      );
    }

    return 0;
  }, [reactionsCount]);
  return { reactionsCount, total };
}
